import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "./baseQuery";
import { ICustomer } from "../../types";

interface CustomerResponse {
  data: {
    users: ICustomer[];
    totalCount: number;
  };
}

interface CustomerDetailsResponse {
  data: ICustomer;
}

export const customerApi = createApi({
  reducerPath: "customerApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getCustomerList: builder.query<
      CustomerResponse,
      { page: number; search?: string }
    >({
      query: ({ page, search }) => {
        let url = `/user/list?pageNumber=${page}&pageSize=10`;
        if (search) url += `&search=${encodeURIComponent(search)}`;
        return {
          url,
          method: "GET",
        };
      },
    }),
    getCustomerDetails: builder.query<CustomerDetailsResponse, number>({
      query: (userId) => ({
        url: `/user/details?userId=${userId}`,
        method: "GET",
      }),
    }),
    updateUserStatus: builder.mutation<
      void,
      { userId: number; status: number }
    >({
      query: (body) => ({
        url: "/user/status",
        method: "PUT",
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token")?.toString() || "",
        },
      }),
    }),
  }),
});

export const {
  useGetCustomerListQuery,
  useGetCustomerDetailsQuery,
  useUpdateUserStatusMutation,
} = customerApi;
